<script setup>
const route = useRoute()
</script>

<template>
    <div class="page-main-wrapper" :data-route="route?.meta?.pageName">
        <slot />
    </div>
</template>

<style lang="scss">
.page-main-wrapper {
    grid-template-rows: auto 1fr auto;
    min-height: 100dvh;
    overflow: hidden;

    @include page-grid;

    &:has(.shop-list) {
        overflow: revert;
    }
}
</style>
